import { dateTimePickerClearableProps } from "@/utils/componentUtils";
import { resolveFormValidationError } from "@/utils/formUtils";
import { dateToUtcIsoDateTimeString } from "@/utils/utils";
import { validations } from "@/utils/validationUtils";
import { DatePicker, Form, Modal } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useScheduleJob } from "../../../../common/api/queries/jobs";
import { ModalSizes } from "../../../../common/constants";
import { JobSettings, ScheduleJobRequest } from "../../types";

interface Props {
  job?: JobSettings;
  onFormCancel: () => void;
}

export const ScheduleJobForm = ({ job, onFormCancel }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<ScheduleJobRequest>();

  const scheduleJob = useScheduleJob();

  const handleFormSubmit = () => {
    if (job) {
      form
        .validateFields()
        .then((values) => scheduleJob.mutate({ id: job.id, object: values }, { onSuccess: onFormCancel }))
        .catch(resolveFormValidationError);
    }
  };

  return (
    <Modal
      width={ModalSizes.TINY}
      open={!!job}
      title={job ? t("job.titles.scheduleJob", { jobName: job.name }) : undefined}
      okText={t("common.save")}
      cancelText={t("common.cancel")}
      confirmLoading={scheduleJob.isPending}
      afterClose={() => form.resetFields()}
      onOk={handleFormSubmit}
      onCancel={onFormCancel}
      mask={{ closable: false }}
    >
      <Form form={form} layout="vertical" name="scheduleJobForm">
        <Form.Item
          name="scheduledFor"
          label={t("job.attrs.record.scheduledFor")}
          rules={[validations.none]}
          getValueProps={(value) => ({ value: value && dayjs(value) })}
          normalize={(value) => dateToUtcIsoDateTimeString(value)}
        >
          <DatePicker style={{ width: "100%" }} {...dateTimePickerClearableProps} showTime />
        </Form.Item>
      </Form>
    </Modal>
  );
};
